var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileArchive = function SvgFileArchive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svgr-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 3v26h20V3Zm2 2h7v1h2V5h7v22H8Zm7 2v2h2V7Zm0 3v2h2v-2Zm0 3v2.188c-1.156.417-2 1.519-2 2.812 0 1.645 1.355 3 3 3s3-1.355 3-3c0-1.293-.844-2.395-2-2.812V13Zm1 4c.563 0 1 .438 1 1s-.437 1-1 1-1-.437-1-1 .438-1 1-1"
  })));
};
export default SvgFileArchive;